import { complement, either, isNil, isEmpty } from "ramda";

export const isBlank = either(isNil, isEmpty);

export const isPresent = complement(isBlank);
